import React from 'react';
import { Play, AlertCircle, WifiOff, Route, CheckCircle2 } from 'lucide-react';
type DemoState = 'normal' | 'hos' | 'offline' | 'bridge';
interface DemoControlsProps {
  currentState: DemoState;
  onStateChange: (state: DemoState) => void;
}
export function DemoControls({
  currentState,
  onStateChange
}: DemoControlsProps) {
  return <div className="fixed bottom-24 right-6 z-50 glass-panel rounded-xl p-3 flex flex-col gap-2 shadow-2xl border-slate-700" data-id="element-173">
      <div className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider px-2 mb-1 flex items-center gap-1.5" data-id="element-174">
        <Play className="w-3 h-3" data-id="element-175" /> Demo Scenarios
      </div>

      <div className="flex flex-col gap-1.5" data-id="element-176">
        <StateButton active={currentState === 'normal'} onClick={() => onStateChange('normal')} icon={<CheckCircle2 className="w-4 h-4" data-id="element-178" />} label="Normal Operations" color="hover:bg-brand-green/20 hover:text-brand-green" activeColor="bg-brand-green/20 text-brand-green border-brand-green/30" data-id="element-177" />
        <StateButton active={currentState === 'hos'} onClick={() => onStateChange('hos')} icon={<AlertCircle className="w-4 h-4" data-id="element-180" />} label="HOS Critical Alert" color="hover:bg-brand-red/20 hover:text-brand-red" activeColor="bg-brand-red/20 text-brand-red border-brand-red/30" data-id="element-179" />
        <StateButton active={currentState === 'bridge'} onClick={() => onStateChange('bridge')} icon={<Route className="w-4 h-4" data-id="element-182" />} label="Bridge Clearance" color="hover:bg-brand-amber/20 hover:text-brand-amber" activeColor="bg-brand-amber/20 text-brand-amber border-brand-amber/30" data-id="element-181" />
        <StateButton active={currentState === 'offline'} onClick={() => onStateChange('offline')} icon={<WifiOff className="w-4 h-4" data-id="element-184" />} label="Driver Offline" color="hover:bg-slate-700 hover:text-slate-300" activeColor="bg-slate-800 text-slate-200 border-slate-600" data-id="element-183" />
      </div>
    </div>;
}
function StateButton({
  active,
  onClick,
  icon,
  label,
  color,
  activeColor
}: any) {
  return <button onClick={onClick} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all border border-transparent
        ${active ? activeColor : `text-slate-400 ${color}`}`} data-id="element-185">
      {icon}
      {label}
    </button>;
}